import { FirestoreCollections, ID } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';

export type GetFcmTokenDocOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  token?: ID;
  installationId?: ID;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
};

export const getFcmTokenDoc = <TDocRef, TDb = FirestoreInstance>(
  options: GetFcmTokenDocOptions<TDocRef, TDb>,
): TDocRef => {
  const { token, installationId, db, doc } = options;
  const docId = installationId ?? token;
  if (!docId) {
    throw new Error('getFcmTokenDoc requires a token or installationId');
  }
  return doc(db, FirestoreCollections.FcmTokens, docId);
};
